export type TextAttribute = {
  value: string;
  name: string;
  transformed: boolean;
};
export type TextAttributesGroup = {
  name: string;
  attributes: TextAttribute[];
};

export const TEXT_ATTRIBUTES: TextAttributesGroup[] = [
  {
    name: 'Prospect',
    attributes: [
      {
        name: 'First name',
        value: 'prospect.first_name',
        transformed: false,
      },
      {
        name: 'Last name',
        value: 'prospect.last_name',
        transformed: false,
      },
      {
        name: 'Email',
        value: 'prospect.email',
        transformed: false,
      },
      {
        name: 'Title',
        value: 'prospect.title',
        transformed: false,
      },
      {
        name: 'Role',
        value: 'prospect.role',
        transformed: false,
      },
      {
        name: 'Phone',
        value: 'prospect.phone',
        transformed: false,
      },
      {
        name: 'Score',
        value: 'prospect.score',
        transformed: false,
      },
    ],
  },
  {
    name: 'Company',
    attributes: [
      {
        name: 'Id',
        value: 'company.id',
        transformed: false,
      },
      {
        name: 'Name',
        value: 'company.name',
        transformed: false,
      },
      {
        name: 'Domain',
        value: 'company.domain',
        transformed: false,
      },
    ],
  },
  {
    name: 'Inbox',
    attributes: [
      {
        name: 'Name',
        value: 'inbox.name',
        transformed: false,
      },
      {
        name: 'Friendly name',
        value: 'inbox.friendly_name',
        transformed: false,
      },
      {
        name: 'Email',
        value: 'inbox.email',
        transformed: false,
      },
      {
        name: 'Signature',
        value: 'inbox.signature',
        transformed: false,
      },
      {
        name: 'Reply to',
        value: 'inbox.reply_to',
        transformed: false,
      },
    ],
  },
  {
    name: 'Precomputed',
    attributes: [
      {
        name: 'Unsubscribe',
        value:
          'If you do not want further emails from me, please click <a href="{{=unsubscribe}}" target="_blank">here</a>',
        transformed: true,
      },
      {
        name: 'Colleagues',
        value: '=company.colleagues',
        transformed: false,
      },
      {
        name: 'Day + X',
        value: '=day+0',
        transformed: false,
      },
      {
        name: 'Day - X',
        value: '=day-0',
        transformed: false,
      },
      {
        name: 'Business day + X',
        value: '=bday+0',
        transformed: false,
      },
      {
        name: 'Business day - X',
        value: '=bday-0',
        transformed: false,
      },
    ],
  },
];
